import React from 'react';

import {SelectWithBodyPopup} from 'client/common/components/lego';

import {
    AudienceCategoryInfo,
    AudienceCategoryValue,
    GeoValue,
    Population
} from 'client/common/types';

import {POPULATION_SELECT_OPTIONS} from './consts';

import {
    filterCountryRegionsChangeOnCountrySelect,
    getPopulationToValue,
    getSelectedPopulation,
    handleSelectChange
} from './helpers';

interface PopulationSelectProps {
    geoValue: AudienceCategoryValue[];
    categories: AudienceCategoryInfo[];
    onChange: (value: AudienceCategoryValue[]) => void;
    disabled: boolean;
}

export default function PopulationSelect(props: PopulationSelectProps) {
    const {categories, geoValue, onChange, disabled} = props;

    const selectedPopulation = getSelectedPopulation(geoValue, categories);
    const populationToValue = getPopulationToValue(categories);

    const handleValueChange = filterCountryRegionsChangeOnCountrySelect(geoValue, onChange);

    const handlePopulationChange = handleSelectChange(
        (populations: (Population | 'allRussia')[]) => {
            const values = populations.reduce((acc, population) => {
                if (population === 'allRussia') {
                    return [...acc, GeoValue.Russia];
                }

                return [...acc, ...populationToValue[population]];
            }, []);

            handleValueChange(values);
        }
    );

    return (
        <SelectWithBodyPopup
            onChange={handlePopulationChange}
            options={POPULATION_SELECT_OPTIONS}
            value={selectedPopulation}
            disabled={disabled}
            view='dl-clear'
            size='m'
            width='max'
        />
    );
}
